<template>
  <div>
    <iframe :src="iframeSrc" frameborder="0" width="100%" height="100%" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0;"></iframe>
  </div>
</template>


<script>
import RestClient from '@/client/rest-client';

export default {
  computed: {
    username() {
      // Retrieve the username from the RestClien
      return RestClient.email;
    },
    tenantId() {
      // Retrieve the token from the RestClient
      return RestClient.tenantId;
    },
    token() {
      // Retrieve the token from the RestClient
      return RestClient.accessToken;
    },
    APIurl() {
      // Retrieve the APIurl from the RestClient
      return RestClient.apiUrl;
    },
    iframeSrc() {
      // Build the URL with the username, token, and APIurl
      const baseUrl = "https://analytics.hydraship.com";
      const queryParams = new URLSearchParams();
      queryParams.append('username', this.username);
      queryParams.append('token', this.token);
      queryParams.append('tenantId', this.tenantId);
      queryParams.append('app', this.APIurl);
      queryParams.append('embed', true);
      queryParams.append('embed_options', 'light_theme');

      // Combine the base URL and query parameters
      return `${baseUrl}/?${queryParams.toString()}`;
    }
  }
}
</script>
